import { useEffect, type DependencyList } from "react"

/**
 * Runs an async effect with a stale guard. The returned `isActive()` becomes false
 * when the effect is cleaned up (including React StrictMode's mount/unmount cycle),
 * so callers can skip state updates from abandoned requests.
 */
export function useAsyncEffect(
  effect: (isActive: () => boolean) => Promise<void> | void,
  deps: DependencyList,
) {
  useEffect(() => {
    let active = true
    const isActive = () => active

    void Promise.resolve(effect(isActive))

    return () => {
      active = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
